import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.642 1.044q0 .225.157.382l4.353 4.353q.157.18.382.18c.225 0 .276-.06.381-.18l4.353-4.353a.52.52 0 0 0 .157-.382.52.52 0 0 0-.157-.381L9.774.169a.56.56 0 0 0-.381-.168.48.48 0 0 0-.382.146L5.534 3.625 2.056.147A.48.48 0 0 0 1.674 0a.56.56 0 0 0-.381.168L.799.663a.52.52 0 0 0-.157.381"
    }, null, -1)
  ]))]))
}
export default { render: render }